import { render, staticRenderFns } from "./EmployeesWidget.vue?vue&type=template&id=607e3739&scoped=true"
import script from "./EmployeesWidget.vue?vue&type=script&lang=js"
export * from "./EmployeesWidget.vue?vue&type=script&lang=js"
import style0 from "./EmployeesWidget.vue?vue&type=style&index=0&id=607e3739&prod&lang=scss&scoped=true"
import style1 from "./EmployeesWidget.vue?vue&type=style&index=1&id=607e3739&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607e3739",
  null
  
)

export default component.exports